export default "__VITE_ASSET__CGNJImUv__"